export default ({request}) => ({
  sysVersionListApi(data = {}) {
    return request({
      url: '/sys/sysVersion/list',
      method: 'post',
      data,
    })
  },
  sysVersionDetailApi(data = {}) {
    return request({
      url: '/sys/sysVersion/detail',
      method: 'post',
      data,
    })
  },
  sysVersionSaveApi(data = {}) {
    return request({
      url: '/sys/sysVersion/save',
      method: 'post',
      data,
    })
  },
  sysVersionDelApi(data = {}) {
    return request({
      url: '/sys/sysVersion/del',
      method: 'post',
      data,
    })
  },
  sysVersionModiStatusApi(data = {}) {
    return request({
      url: '/sys/sysVersion/modiStatus',
      method: 'post',
      data,
    })
  },
  sysVersionDisplayListApi(data = {}) {
    return request({
      url: '/sys/sysVersion/displayList',
      method: 'post',
      data,
    })
  },
  sysVersionLastVersionApi(data = {}) {
    return request({
      url: '/sys/sysVersion/lastVersion',
      method: 'post',
      data,
    })
  },
})
